import { render } from "./EvidenceStatus.vue?vue&type=template&id=201db500&scoped=true"
import script from "./EvidenceStatus.vue?vue&type=script&lang=js"
export * from "./EvidenceStatus.vue?vue&type=script&lang=js"

import "./EvidenceStatus.vue?vue&type=style&index=0&id=201db500&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201db500"]])

export default __exports__